import TEAMS from "./teams.json";

// Pick `count` distinct random team ids for a ranked match.
export function generateMatchTeams(count = 11) {
  const pool = [...TEAMS];
  const picked = [];
  for (let i = 0; i < count && pool.length; i++) {
    const idx = Math.floor(Math.random() * pool.length);
    picked.push(pool[idx].id);
    pool.splice(idx, 1);
  }
  return picked;
}

// Resolve stored team ids back to full team objects from teams.json.
export function resolveTeams(ids) {
  return (ids || [])
    .map((id) => TEAMS.find((t) => t.id === id))
    .filter(Boolean);
}

export function resolveTeam(id) {
  return TEAMS.find((t) => t.id === id) || null;
}
